import React, { use, useEffect, useState } from 'react';
import { Card, Row, Col } from 'antd';
import CustomerForm from '../components/Customer/CustomerForm';
import CustomerList from '../components/Customer/CustomerList';
import { Customer } from '../types/customer';
import { useTranslation } from "react-i18next";
import { useCustomer } from '../store/customerContext';
import { useAuth } from '../store/AuthContext';

const CustomersPage: React.FC = () => {
  const [editCustomer, setEditCustomer] = useState<Customer | undefined>(undefined);
  const { lisOfCustomers } = useCustomer();
  const { t, i18n } = useTranslation();
  const { hasPermission } = useAuth();



  useEffect(() => {
    lisOfCustomers();
  }, []);

  return (
    <div style={{ padding: 16, direction: i18n.language === 'ar' || i18n.language === 'ckb' ? 'rtl' : 'ltr' }}>
      <Row gutter={[16, 16]}>
        {hasPermission("customer.create") || hasPermission("customer.update") ?
        <Col xs={24} md={10} lg={8}>
          <Card title={editCustomer ? t('edit_customer') : t('add_customer')}>
            <CustomerForm editCustomer={editCustomer} onFinishEdit={() => setEditCustomer(undefined)} />
          </Card>
          </Col> : null}
        <Col xs={24} md={14} lg={16}>
          <Card title={t('customer_list')}>
            <CustomerList onEdit={setEditCustomer} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CustomersPage;
